import { render, staticRenderFns } from "./Sso.vue?vue&type=template&id=059c24e5&scoped=true"
import script from "./Sso.vue?vue&type=script&lang=ts"
export * from "./Sso.vue?vue&type=script&lang=ts"
import style0 from "./Sso.vue?vue&type=style&index=0&id=059c24e5&prod&scoped=true&lang=css"
import style1 from "./Sso.vue?vue&type=style&index=1&id=059c24e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059c24e5",
  null
  
)

export default component.exports